/**
 * MediaLightbox testid registry (FR1-PRE-003). Never hardcode these strings in
 * specs — import MEDIA_LIGHTBOX from @modules/ui-components or @test-kit.
 */

export const MEDIA_LIGHTBOX = {
  root: 'media-lightbox',
  close: 'media-lightbox-close',
  title: 'media-lightbox-title',
  counter: 'media-lightbox-counter',
  stage: 'media-lightbox-stage',
  image: 'media-lightbox-image',
  video: 'media-lightbox-video',
  prev: 'media-lightbox-prev',
  next: 'media-lightbox-next',
  zoomIn: 'media-lightbox-zoom-in',
  zoomOut: 'media-lightbox-zoom-out',
  zoomFit: 'media-lightbox-zoom-fit',
  zoomLabel: 'media-lightbox-zoom-label',
  download: 'media-lightbox-download',
  openOriginal: 'media-lightbox-open-original',
  openDetails: 'media-lightbox-open-details',
  metaPanel: 'media-lightbox-meta',
} as const;
